import Experience from '../Experience.js'
import Environment from './Environment.js'
import Floor from './Floor.js'
import Fox from './Fox.js'
import Logo from '../Logo.js'
import Text from '../Text.js'
import Background from '../Background.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            this.floor = new Floor()
            this.fox = new Fox()
            this.environment = new Environment()
            this.logo = new Logo()
            this.text = new Text()
            this.background = new Background()

        })
    }

    update()
    {
        if(this.fox)
            this.fox.update()
            
        if(this.logo)
            this.logo.update()

        if(this.text) {
            this.text.update()
        }

        if(this.background) {
            this.background.update()
        }


    }
}